import { render } from "./TheBoMonTheThaoVH.vue?vue&type=template&id=c4b26908"
import script from "./TheBoMonTheThaoVH.vue?vue&type=script&lang=js"
export * from "./TheBoMonTheThaoVH.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__